import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

const HomeButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<HomeIcon />}
      onClick={() => navigate('/')}
    >
      Home
    </Button>
  );
};

export default HomeButton; 